import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, EventEmitter, inject, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FrotaService } from 'src/app/frota/frota.service';
import {
  IFiltroFrotaModel,
  IFrotaModel,
} from 'src/app/frota/model/frota.model';
import { RedeEspecialService } from '../rede-especial.service';
import { MatPaginator } from '@angular/material/paginator';
import { Dialog } from '@angular/cdk/dialog';
import { MatGridList, MatGridListModule, MatGridTile } from '@angular/material/grid-list';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSpinnerOverlayComponent } from 'src/app/components/mat-spinner-overlay/mat-spinner-overlay.component';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-filtrar-frota',
  templateUrl: './filtrar-frota.component.html',
  styleUrls: ['./filtrar-frota.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatSpinnerOverlayComponent,
    MatDialogModule
  ],
})
export class FiltrarFrotaComponent implements OnInit {

  private frotaService = inject(FrotaService);
  private redeEspecialService = inject(RedeEspecialService);

  displayedColumns = ['codigo', 'descricao', 'nomeReduzido', 'municipio', 'estado'];
  public loading: number = 0;
  items = new MatTableDataSource<IFrotaModel>([]);

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  selectedItem?: IFrotaModel;


  selectUm = [
    { value: '1', viewValue: 'Por Código' },
    { value: '2', viewValue: 'Por Nome Fantasia' },
    { value: '3', viewValue: 'Por Razão Social' },
    { value: '4', viewValue: 'Por Cidade' },
    { value: '5', viewValue: 'Por UF' },
  ];
  coluna  = this.selectUm.map((opcao) => opcao.value)[isNaN(this.data) ? 1 : 0];

  selectDois = [
    { value: 1, viewValue: 'Igual a' },
    { value: 2, viewValue: 'Maior que' },
    { value: 3, viewValue: 'Menor que' },
    { value: 4, viewValue: 'Contendo' },
    { value: 5, viewValue: 'Iniciando por' },
  ];
  operador: number = this.selectDois.map((opcao) => opcao.value)[isNaN(this.data) ? 3 : 0];

  filtro: IFiltroFrotaModel = {
    guid: this.redeEspecialService.usuario.retorno.guid,
    coluna: this.coluna.toString(),
    operador: this.operador,
    parametro: this.data,
  };



  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    public dialogRef: MatDialogRef<FiltrarFrotaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.getFrota();

  }

  gerenciarSelect(frota: IFrotaModel) {
    this.selectedItem = frota;
    this.filtro.parametro = frota.nomeReduzido;

    this.dialogRef.close(this.selectedItem);

  }


  getFrota() {
    this.loading++;
    this.frotaService.listFrota(this.filtro).subscribe((response) => {
      if (response.sucesso) {
        this.items.data = response.retorno.map((item) => {
          return {
            selected: false,
            descricao: item.descricao,
            codigo: item.codigo,
            nomeReduzido: item.nomeReduzido,
            municipio: item.municipio,
            estado: item.estado,
            busca: ''
            };
        }
        );
        this.items.paginator = this.paginator;
        this.items.sort = this.sort;

        this.loading--;
      } else {
        this.loading--;
      }
    });
  }

  limpaFiltro(): void {
    this.filtro.parametro = '';
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }




}
